import * as React from 'react';

import { Avatar, AvatarFallback } from '@savgroup-front-common/primitive/ui/avatar';

import { getAvatarVariant, getInitials } from './user-avatar.helpers';

type UserAvatarProps = Omit<React.ComponentProps<typeof Avatar>, 'children'> &
  Pick<React.ComponentProps<typeof AvatarFallback>, 'variant'> & {
    fullName?: string;
  };

export function UserAvatar({ fullName = '', variant, ...props }: UserAvatarProps) {
  return (
    <Avatar {...props}>
      <AvatarFallback variant={variant ?? getAvatarVariant(fullName)}>
        {getInitials(fullName)}
      </AvatarFallback>
    </Avatar>
  );
}
